import { Injectable } from '@angular/core';
import { Router, CanActivate, CanActivateChild, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { SmartLocalStorageService } from '../services/smart-local-storage.service';
import { Observable } from 'rxjs';
import { OverlayService } from '../services/overlay.service';
import { map } from 'rxjs/operators';
import { MaintenanceService } from '../services/maintenance.service';

@Injectable()
export class AuthGuard implements CanActivate, CanActivateChild {
	constructor(
		private router: Router,
		private storage: SmartLocalStorageService,
		private overlay: OverlayService,
		private maintenace: MaintenanceService
	) {}

	canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
		return this.storage.localStorageUser.pipe(
			map((user) => {
				if (this.maintenace.inMaintenance()) {
					this.maintenace.redirectToMaintenancePage();
				} else {
					const isUser = Boolean(this.storage.isUser(user));
					const isExpired = Boolean(this.storage.isExpired());

					if ((isExpired || !isUser) && !this.maintenace.inMaintenance()) {
						this.overlay.updateOverlay(false);
						this.router.navigate(['/login']);
					}

					return !!user;
				}
			})
		);
	}

	canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
		return this.canActivate(route, state);
	}
}
